var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"mr-3 mb-3",style:(_vm.buttonStyle),on:{"click":_vm.handle}},[_vm._v(_vm._s(_vm.button.text))])}
var staticRenderFns = []

export { render, staticRenderFns }